export default __webpack_public_path__ + "static/media/_1208900.5cc8bda4.webp";